import React from 'react';
import './App.css';
import HiraganaQuiz from './components/HiraganaQuiz';

function App() {
  return (
    <div className="App">
      <HiraganaQuiz />
    </div>
  );
}

export default App;
